// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__a_uS2","infoWrapper":"styles_infoWrapper__hBtDV","title":"styles_title__e_y3h","info":"styles_info__CxHkE","buttonWrapper":"styles_buttonWrapper__JRsFI","button":"styles_button__Dz9xA"};
module.exports.__checksum = "2498992d7909"
